import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Image } from 'antd';
import cbplogo from "../../../assets/images/us-cbp-logo.png";

const CustomsContact = ({ airportName, iataCode }) => {
  const navigate = useNavigate();

  return (
    <Card
      className="airline-card customs-card"
      style={{
        cursor: 'pointer',
        marginTop: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0
      }}
      onClick={() => navigate(`/airport/${iataCode}/customs`, {
        state: { airportName, iataCode }
      })}
    >
      <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Image
          className="airline-img zl-custom-img"
          src={cbplogo}
          preview={false}
          alt="US CBP Logo"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </div>
    </Card>
  );
};

export default CustomsContact;